import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';
import { Loader } from 'components/Loader/Loader';
import { ReactNode } from 'react';
import { frameHeight } from 'stylesheet';

import { getButtonSx } from './Button.style';

export type ButtonDisplayStyle =
  | 'filledOrange'
  | 'unfilledOrange'
  | 'unfilledGrey'
  | 'filledRed'
  | 'filledGreen'
  | 'unfilledgreen'
  | 'unfilledWhite'
  | 'filledBlue';
export type AdditionalButtonProps = {
  displayStyle: ButtonDisplayStyle;
  margins?: string;
  bigPaddings?: boolean;
  isLoading?: boolean;
  children?: ReactNode;
  justifyContentLeft?: boolean;
  widthInPx?: number;
  allSidePadding?: string;
  isMobile?: boolean;
  title?: string;
};
type ButtonProps = MuiButtonProps & AdditionalButtonProps;

export const Button = ({
  isMobile,
  displayStyle,
  margins,
  bigPaddings,
  startIcon,
  href,
  disabled,
  onClick,
  onMouseEnter,
  onMouseLeave,
  type,
  isLoading,
  children,
  justifyContentLeft,
  widthInPx,
  allSidePadding,
  title,
  ...rest
}: ButtonProps) => {
  const buttonSx = getButtonSx({
    displayStyle,
    margins,
    bigPaddings,
    isLoading,
    children,
    justifyContentLeft,
    widthInPx,
    allSidePadding,
    isMobile,
  });
  return (
    <MuiButton
      sx={buttonSx}
      disabled={disabled}
      href={href}
      onClick={isLoading ? () => null : onClick}
      onMouseEnter={onMouseEnter ? onMouseEnter : () => null}
      onMouseLeave={onMouseLeave ? onMouseLeave : () => null}
      startIcon={startIcon}
      type={type}
      disableFocusRipple
      title={title}
      {...rest}
    >
      {children}
      {isLoading && (
        <Loader sizeInPx={frameHeight.buttonInnerSize} color="inherit" position="absolute" />
      )}
    </MuiButton>
  );
};
